import { render } from "./QueroSerCliente.vue?vue&type=template&id=e6351d5a&scoped=true"
import script from "./QueroSerCliente.vue?vue&type=script&lang=js"
export * from "./QueroSerCliente.vue?vue&type=script&lang=js"

import "./QueroSerCliente.vue?vue&type=style&index=0&id=e6351d5a&scoped=true&lang=css"

import exportComponent from "/home/devnote/Documentos/Features/Home Creditall/site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6351d5a"]])

export default __exports__